export default "__VITE_ASSET__ijcs2yCn__"